// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-orange[data-v-0bb71c6f]{color:#fff;background-color:#ff8c00}.badge-success[data-v-0bb71c6f]{color:#fff;background-color:#02b30b!important}", ""]);
// Exports
module.exports = exports;
